import { render, staticRenderFns } from "./Series.vue?vue&type=template&id=5e3905a0&scoped=true&"
import script from "./Series.vue?vue&type=script&lang=js&"
export * from "./Series.vue?vue&type=script&lang=js&"
import style0 from "./Series.vue?vue&type=style&index=0&id=5e3905a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3905a0",
  null
  
)

export default component.exports